import { PhotoflipperModalAsync } from 'site-modules/shared/components/photoflipper-core/photoflipper-modal/photoflipper-modal-async';
import { getPhotoflipperButton } from './get-photoflipper-button';

export const PhotoflipperButtonAsync = getPhotoflipperButton(PhotoflipperModalAsync);
